<template>
  <div class="intelService" v-show="isVisible">
    <div class="intelService-title">
        <p>智能客服小二</p>
        <i class="el-icon-minus" @click="visible()"></i>
        <i class="el-icon-close" @click="close()"></i>
    </div>
    <div class="intelService-content" ref="intelService">
        <transition-group name="list" tag="p">
            <div v-for="(item,index) in chatList" :key="index">
                <!-- 时间 -->
                <div class="intelService-time" v-if="item.type=='time'">
                    {{item.data}}
                </div>
                <!-- 客服回复 -->
                <div class="intelService-kefu" v-if="item.type=='kefu'">
                    <div class="intelService-kefu-icon">
                        <img src="@/assets/serve.png" alt="" v-if="item.icon">
                    </div>
                    <div class="intelService-kefu-p" v-if="!item.isUseful">
                        <h6>猜你想问：</h6>
                        <p v-for="(child,indexs) in item.data" :key="indexs" @click="clickQuestion(item.isQuestion,child.questionName,child.id)" class="intelService-kefu-link">
                            {{indexs+1}}、{{child.questionName}}
                        </p>
                        <div class="next_btn" v-if="item.total > pageSize && item.data.length < item.total"><span @click="onNext(item,index)">下一页</span></div>
                    </div>
                    <div v-else-if="item.isAnswer" class="intelService-kefu-p">
                        {{item.questionReply}}
                    </div>
                    <div v-else class="intelService-kefu-p">
                        {{item.questionName}}
                    </div>
                </div>
                <!-- 用户询问 -->
                <div class="intelService-youke" v-if="item.type=='youke'">
                    <div class="intelService-youke-icon">

                    </div>
                    <div class="intelService-youke-p">
                        {{item.questionName}}
                    </div>
                </div>
            </div>
        </transition-group>

    </div>
    <div class="intelService-input">
        <el-input type="textarea" placeholder="输入限999" v-model="question" maxlength="999" resize="none">
        </el-input>
        <div class="intelService-submit">
            <i>{{question.length}}/999</i>
            <el-button type="main" size="mini" @click="inputEnter">发送</el-button>
        </div>
    </div>
</div>
</template>
<script>
/**
 * Component intelService 智能客服组件
 	@author fanjun
  @props data（必选属性前面带＊，非必选项目请备注默认值）
   －*type : String,'1'(默认) 
	@example
	<intelService />
**/
import './index.scss'
import {Icon , Input ,Button ,Message} from 'element-ui'

export default {
  name: 'intelService',
  components:{
    [Icon.name]:Icon,
    [Input.name]:Input,
    [Button.name]:Button,
  },
  props:{
    type: {
      type: String,
      required: false,
      default: '1'
    },
  },
  data(){
    return{
      isVisible: false,
      question: '',
      chatList: [] ,// 聊天列表
      updateTime: true,
      Timer: null,
      pageSize:10
    }
  },
  created(){
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.chatList = [];
      //获取当前时间
      this.isUpdateTime();
      // 常用语1
      this.$api.getCommonLanguageById({id:'1'}).then(res=>{
        if(res.data.resultCode==200){
          let data = Object.assign({type:'kefu',icon:true,isQuestion:false,isUseful:true},res.data.result);
          this.chatList.push(data);
          // 常用语1
          this.$api.getCommonLanguageById({id:'2'}).then(res=>{
            if(res.data.resultCode==200){
              let data = Object.assign({type:'kefu',icon:false,isQuestion:false,isUseful:true},res.data.result);
              this.chatList.push(data);
            }else{
              Message({
                message: res.data.resultDesc,
                type: 'error',
                duration: 10000
              })
            }
          }).catch(err=>{
            console.log(err)
          })
          // 
        }else{
          Message({
            message: res.data.resultDesc,
            type: 'error',
            duration: 10000
          })
        }
      }).catch(err=>{
        console.log(err)
      }) 
    },
    // 是否更新时间
    isUpdateTime(){
      console.log(this.updateTime)
      if(this.updateTime){
        this.chatList.push({
          type: 'time',
          data: this.getNowTime()
        });
        this.updateTime = false ;
        // 延时器
        clearTimeout(this.Timer);
        this.Timer= setTimeout(()=>{
          this.updateTime = true ;
        },60000);
      }    
    },
    // 打开客服
    open(){
      this.isVisible = true;
    },
    // 关闭客服
    close(){
      this.isVisible = false;
      this.updateTime = true;
      this.question = '';
      this.init();
    },
    // 隐藏客服
    visible(){
      this.isVisible = false;
    },
    //客服下一页
    onNext(data,index){
      console.log(data.pageNum)
      console.log(this.chatList)
      this.getBack(data.question,Number(data.pageNum)+1,index)
    },
    // 获取当前时间
    getNowTime() {
      var date = new Date();  
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var hour  = date.getHours();
      hour = hour < 10 ? ('0' + hour) : hour;
      var minutes  = date.getMinutes();
      minutes = minutes < 10 ? ('0' + minutes) : minutes;
      var second   = date.getSeconds();
      second = second < 10 ? ('0' + second) : second;
      return y + '-' + m + '-' + d +' '+hour+':'+minutes+':'+second;
    },
    // 获取当前时间
    dateFormat:function() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + m + '-' + d;
    },
    // 输入框
    inputEnter(){
      let string = (this.question +'').replace(/(^\s*)|(\s*$)/g, "");
      if(string=='' || string==null || string == undefined ||string=='/n'){
        return Message({
          message: '请您先填写询问信息',
          type: 'warning'
        })
      }
      console.log(this.question);
      this.chatList.push({
        type: 'youke',
        questionName: this.question       
      });
      //查询接口
      this.getBack(this.question);
      // 滑动到底部
      this.scrollBottom();
    },
    // 关键字获取问题库
    getBack(question,pageNum,index){
      //更新当前时间判定
      this.isUpdateTime();
      // 获取回复
      this.$api.getKnowledgeRequestionByKeyword({
        questionName:question,
        pageNum: pageNum?pageNum:1,
        pageSize: this.pageSize
      }).then(res=>{
        console.log(res)
        if(res.data.resultCode==200){
          // let data = Object.assign({type:'kefu',icon:true,isQuestion:true},res.data);
          let data = {
            type: 'kefu',
            icon: true,
            isQuestion: true,
            data: res.data.result,
            isUseful: false,
            total: res.data.total,
            pageNum:pageNum?pageNum:1,
            question:question
          }
          if(index){
            this.chatList[index].data.push.apply(this.chatList[index].data,res.data.result);            
            console.log(this.chatList)
          }else{
            this.question = '';   
            this.chatList.push(data);
          }         
          // 滑动到底部
          this.scrollBottom();
        }else if(res.data.resultCode==3001){
          // 常用语3
          this.$api.getCommonLanguageById({id:'3'}).then(res=>{ 
            if(res.data.resultCode==200){
              let data = Object.assign({type:'kefu',icon:true,isQuestion:false,isUseful:true},res.data.result);
              this.chatList.push(data);
              this.question = ''; 
              this.scrollBottom();
            }else{
              Message({
                message: res.data.resultDesc,
                type: 'error',
                duration: 10000
              })
            }
          }).catch(err=>{
            console.log(err)
          }) 
          // 
        }else{
          Message({
            message: res.data.resultDesc,
            type: 'error',
            duration: 10000
          })
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 点击问题
    clickQuestion(boolean,question,id){
      if(boolean){
        this.chatList.push({
          type: 'youke',
          questionName: question    
        });
        //查询接口
        this.getAnswer(id);
        // 滑动到底部
        this.scrollBottom();
      }    
    },
    // 匹配问题答案
    getAnswer(id){
      // 获取回复
      this.$api.getKnowledgeRequestionById({
        id: id
      }).then(res=>{
        console.log(res.data)
        if(res.data.resultCode==200){
          let data = Object.assign({type:'kefu',icon:true,isAnswer:true,isUseful:true},res.data.result);
          this.chatList.push(data);
          // 滑动到底部
          this.scrollBottom();
        }else{
          Message({
            message: res.statusText,
            type: 'error',
            duration: 10000
          })
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 滑动到底部
    scrollBottom(){
      this.$nextTick(() => {
        this.$refs['intelService'].scrollTop=this.$refs['intelService'].scrollHeight ;
      })
    }            
  }
}
</script>

